import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'

import { Store } from '@ngrx/store'
import { OAuthService } from 'angular-oauth2-oidc'

import { Observable, tap } from 'rxjs'

import { environment } from '@flowx/designer/environment'
import {
  ORGANIZATION_ADMIN_WORKSPACE_ID,
  WORKSPACE_ID_HEADER,
} from '@flowx/designer/modules/workspaces/shared/commons.types'
import { REQUEST_SCOPE } from '@flowx/designer/shared/api/request-scope.token'
import { selectWorkspaceId } from '@flowx/designer/shared/store/selectors/router.selectors'

@Injectable()
export class WorkspacesInterceptor implements HttpInterceptor {
  #router = inject(Router)
  #store = inject(Store)
  #oAuthService = inject(OAuthService)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // A call made for a project of its own — a plan call on a conversation's write target — or for
    // a lookup in the workspace a conversation lives in names that workspace itself, which need
    // not be the one the maker is standing in.
    const scope = request.context.get(REQUEST_SCOPE)
    const selectedWorkspaceId =
      scope?.type === 'project' || scope?.type === 'workspace'
        ? scope.workspaceId
        : this.#store.selectSignal(selectWorkspaceId)()
    return next
      .handle(
        request.clone({
          setHeaders: {
            ...(!request.url.includes(this.#oAuthService.issuer) &&
              !request.url.includes(environment.staticAssetsPath) &&
              selectedWorkspaceId &&
              selectedWorkspaceId !== ORGANIZATION_ADMIN_WORKSPACE_ID && {
                [WORKSPACE_ID_HEADER]: selectedWorkspaceId ?? '',
              }),
          },
        })
      )
      .pipe(
        tap((event) => {
          // If the response is a 303 it means that the Fx-WorkspaceId request header is not set
          // Navigate to the workspaces-select page
          if (event instanceof HttpResponse && event.status === 303) {
            this.#router.navigate(['workspaces-select'])
          }
        })
      )
  }
}
